
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { TrendingUp, Music, Clock } from "lucide-react";

const performanceData = [
    { name: 'Neon Garden', revenue: 78000 },
    { name: 'Velvet U.', revenue: 45000 },
    { name: 'Warehouse', revenue: 210000 },
    { name: 'Rooftop', revenue: 19500 },
];

const VenueInsights = () => {
    return (
        <div>
            <h2 className="text-2xl font-semibold mb-4 text-white">📊 Insights & Trends</h2>
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3 mb-6">
                <Card className="bg-white/10 border-white/20 text-white">
                    <CardHeader>
                        <CardTitle className="text-base font-medium flex items-center gap-2"><TrendingUp className="h-5 w-5"/> Best Performing Night</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p className="text-2xl font-bold">Friday</p>
                        <p className="text-sm text-gray-400">at Neon Garden</p>
                    </CardContent>
                </Card>
                 <Card className="bg-white/10 border-white/20 text-white">
                    <CardHeader>
                        <CardTitle className="text-base font-medium flex items-center gap-2"><Music className="h-5 w-5"/> Most Popular Genre</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p className="text-2xl font-bold">Techno</p>
                        <p className="text-sm text-gray-400">Across all venues</p>
                    </CardContent>
                </Card>
                 <Card className="bg-white/10 border-white/20 text-white">
                    <CardHeader>
                        <CardTitle className="text-base font-medium flex items-center gap-2"><Clock className="h-5 w-5"/> Peak Attendance</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <p className="text-2xl font-bold">11:00 PM</p>
                        <p className="text-sm text-gray-400">Average peak time</p>
                    </CardContent>
                </Card>
            </div>
            <Card className="bg-white/5 border-white/20 text-white">
                <CardHeader>
                    <CardTitle>Venue Revenue Performance</CardTitle>
                </CardHeader>
                <CardContent className="h-96">
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={performanceData}>
                            <XAxis dataKey="name" stroke="#888888" fontSize={12} tickLine={false} axisLine={false}/>
                            <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} tickFormatter={(value) => `$${value / 1000}k`}/>
                            <Tooltip
                                cursor={{fill: 'rgba(255, 255, 255, 0.1)'}}
                                contentStyle={{
                                    backgroundColor: 'rgba(0,0,0,0.8)',
                                    borderColor: 'rgba(255,255,255,0.2)'
                                }}
                            />
                            <Bar dataKey="revenue" fill="#ffffff" radius={[4, 4, 0, 0]} />
                        </BarChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </div>
    );
};

export default VenueInsights;
